<section>
  <h2>Site Configuration</h2>
  <code id="settings">
    <pre>{{ settings }}</pre>
  </code>
</section>
